import Task, {
    FormOrderTaskDetails,
    FormReorderFormSnapshot,
    FormReorderReason,
    FormReorderTaskDetails,
} from '../../../types/api/task'
import { DocumentId } from '../../../types/strapi/strapi'

type FormOrderDetailsFields = {
    stampId?: DocumentId
    formOrderId?: DocumentId
    reason?: FormReorderReason
    sourceFormIds?: DocumentId[]
    forms?: FormReorderFormSnapshot[]
}

export function getFormOrderDetailsFields(task: Pick<Task, 'details'>): FormOrderDetailsFields {
    return (task.details || {}) as FormOrderDetailsFields
}

export function buildFormOrderSaveDetails(
    task: Task,
    stampId: DocumentId,
    formOrderId: DocumentId
): FormOrderTaskDetails | FormReorderTaskDetails {
    const existing = getFormOrderDetailsFields(task)

    if (task.type === 'Перезаказ форм') {
        return {
            type: 'Перезаказ форм',
            stampId,
            formOrderId,
            reason: existing.reason,
            sourceFormIds: existing.sourceFormIds,
            forms: existing.forms,
        }
    }

    return {
        type: 'Заказ форм',
        stampId,
        formOrderId,
    }
}

export function formatFormReorderDetailsLabel(details: FormOrderDetailsFields): string {
    const reasonLabel =
        details.reason === 'defect' ? 'брак' : details.reason === 'breakage' ? 'поломка' : null
    const prefix = reasonLabel ? `Перезаказ (${reasonLabel})` : 'Перезаказ'
    const forms = details.forms || []

    if (!forms.length) return prefix

    const countLabel = forms.length === 1 ? '1 форма' : `${forms.length} форм`
    const formsText = forms
        .map(form => [form.num, form.colorName].filter(Boolean).join(' '))
        .filter(Boolean)
        .join(', ')

    return formsText ? `${prefix}: ${countLabel} — ${formsText}` : `${prefix}: ${countLabel}`
}
